import { Injectable } from '@angular/core';
import { ClientModels } from 'models/client.models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TableModels } from '../../../../models/table.models';
import {
  projectClientResponse,
  projectClientTableRowResponse,
} from '../projectors/client-projectors';
import { ClientApiService } from './api/client-api.service';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  constructor(private apiService: ClientApiService) {}

  getClients(
    request: ClientModels.ClientsPaginatedRequest,
  ): Observable<TableModels.PaginatedResult<ClientModels.ClientTableRow>> {
    return this.apiService
      .getClients(request)
      .pipe(map(projectClientTableRowResponse));
  }

  getClient(clientId: number): Observable<ClientModels.Client> {
    return this.apiService.getClient(clientId).pipe(map(projectClientResponse));
  }
}
